<template>
  <div class="NavIndex">
    <div class="menu_all flex">
      <div
        class="drap_down flex"
        @mouseleave="outList"
        @mouseenter="showHidList = true"
      >
        <svg
          t="1582095362726"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="7481"
          width="20"
          height="20"
        ><path
          d="M230.6 264h562.8c14.138 0 25.6 11.462 25.6 25.6v0.8c0 14.138-11.462 25.6-25.6 25.6H230.6c-14.138 0-25.6-11.462-25.6-25.6v-0.8c0-14.138 11.462-25.6 25.6-25.6z m0 222h562.8c14.138 0 25.6 11.462 25.6 25.6v0.8c0 14.138-11.462 25.6-25.6 25.6H230.6c-14.138 0-25.6-11.462-25.6-25.6v-0.8c0-14.138 11.462-25.6 25.6-25.6z m0 222h562.8c14.138 0 25.6 11.462 25.6 25.6v0.8c0 14.138-11.462 25.6-25.6 25.6H230.6c-14.138 0-25.6-11.462-25.6-25.6v-0.8c0-14.138 11.462-25.6 25.6-25.6z"
          fill="#fff"
          p-id="7482"
        ></path></svg>
        <span class="hidden-title">{{ union === 'gwgc' ? TLang('劳保用品', 'my') :TLang('优选生活分类', 'my') }}</span>
        <ul
          v-show="showHidList"
          class="hid-list"
        >
          <li
            v-for="item in catList"
            :key="item.id"
            :class="{ 'drap_down-item': true, active: item.id === activeId }"
            @mouseenter="hoverItem(item)"
            @click="
              onChange(item.id,item,1);
              showHidList = false;
            "
          >
            <img
              :src="item.imgUrl"
              alt
            />
            <span>{{ item.name }}</span>
            <i class="icon iconfont">&#xe657;</i>
          </li>
          <li
            v-if="activeItem.subCategoryList && activeItem.subCategoryList.length"
            class="subListCont"
            :style="{ height: catList.length * 44 + 'px' }"
          >
            <p
              @click="
                onChange(activeId,activeItem,1);
                showHidList = false;
              "
            >
              {{ activeTitle }}
            </p>
            <div class="sub-list">
              <div
                v-for="goods in activeItem.subCategoryList"
                :key="goods.id"
                class="sub3-item"
                @click="
                  onChange(goods.id,goods,2);
                  showHidList = false;
                "
              >
                {{ goods.name }}
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- <ul class="naviLink flex">
      <li
        v-for="item in catList"
        :key="item.id"
        :style="{ flex: '0 0 1.7%' }"
        @click="onChange(item.id)"
      >
        <span>{{ item.name }}</span>
      </li>
    </ul> -->
  </div>
</template>

<script>
import { unionFlag } from '@utils';
export default {
  name: 'NavIndex',
  props: {
    catList: Array,
    onChange: Function,
  },
  data() {
    return {
      cateList: [],
      activeTitle: '',
      activeId: null,
      showHidList: false,
      activeItem: {},
      union: unionFlag(),
    };
  },
  mounted() {
  // fetchNavCategory({'channelId': 2}).then(res => {
  //   console.log(res);
  // });
  },
  methods: {
    hoverItem(item) {
      this.cateList = [];
      if (item.name && item.id) {
        this.activeTitle = item.name;
        this.activeId = item.id;
        this.activeItem = item;
      }
      // 改回来继续取二级分类 为activeItem 后面加上git版本号
      // if (item && item.subCategoryList && item.subCategoryList.length > 0) {
      //   item.subCategoryList.map(sub2 => {
      //     if (sub2 && sub2.subCategoryList && sub2.subCategoryList.length > 0) {
      //       sub2.subCategoryList.map(sub3 => {
      //         this.cateList.push(sub3);
      //       });
      //     }
      //   });
      // }
    },
    outList() {
      // this.activeTitle = '';
      // this.activeId = null;
    },
  },
};
</script>

<style scoped lang="less">
.NavIndex {
  display: flex;
  background: #fff;
  height: 44px;
  // box-shadow:0px 1px 8px 0px rgba(0,0,0,0.05);
  .menu_all {
    width: 220px;
    background: linear-gradient(
      315deg,
      rgba(92, 180, 236, 1) 0%,
      rgba(61, 150, 226, 1) 100%
    );
    font-size: 16px;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    line-height: 44px;
    display: flex;
    justify-content: center;
    .drap_down {
      position: relative;
      width: 100%;
      min-width: 200px;
      justify-content: center;
      .hidden-title{
        margin-left: 10px;
      }
      .hid-list {
        position: absolute;
        top: 100%;
        width: 100%;
        background: #fff;
        box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);
        z-index: 999;
        transition: all ease 800ms;
        display: none;
        li.drap_down-item {
          font-size: 14px;
          color: rgba(51, 51, 51, 1);
          display: flex;
          padding-left: 15px;
          padding-right: 10px;
          align-items: center;
          position: relative;
          white-space: nowrap;
          img {
            width: 24px;
            height: 24px;
            vertical-align: middle;
          }
          i {
            transform: rotate(90deg);
            margin-left: auto;
            font-size: 20px;
          }
          span {
            margin-left: 12px;
          }
          &::after {
            content: "";
            display: inline-block;
            height: 1px;
            width: 100%;
            background: #f7f7f7;
            position: absolute;
            bottom: 0;
            left: 0;
          }
        }
        li.drap_down-item:hover {
          cursor: pointer;
          &::after {
            background: #ECF5FD;
          }
        }
        li.active {
          background: #ECF5FD;
          cursor: pointer;
          color: #3D96E2;
          &::after {
            background: #ECF5FD;
          }
          span{
            font-weight: bold;
          }
        }
        .subListCont {
          position: absolute;
          left: 100%;
          top: 0;
          background: #fff;
          color: #000;
          box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
          width: 680px;
          padding: 30px;
          box-sizing: border-box;
          p {
            font-size: 18px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            text-align: left;
            position: relative;
            &:after {
              content: "";
              display: inline-block;
              width: 630px;
              height: 1px;
              background: #f0f0f0;
              position: absolute;
              bottom: 0;
              left: 0;
            }
          }
          .sub-list {
            display: flex;
            flex-wrap: wrap;
            font-size: 12px;
            color: rgba(51, 51, 51, 1);
            max-height: 300px;
            overflow-y: scroll;
            .sub3-item {
              margin-right: 20px;
            }
            .sub3-item:hover {
              font-size: 12px;
              font-weight: bold;
              color: rgba(61, 150, 226, 1);
              cursor: pointer;
            }
          }
        }
      }
    }
    .drap_down:hover {
      cursor: pointer;
    }
    .drap_down:hover ul {
      display: block;
    }
  }
  ul.naviLink {
    font-size: 16px;
    color: rgba(34, 34, 34, 1);
    margin-left: 20px;
    li {
      margin-left: 15px;
      white-space: nowrap;
      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>
